import { getProductRequests } from '@/api/product-request';

const APPEND_PRODUCT_REQUESTS = 'APPEND_PRODUCT_REQUESTS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_PRODUCT_REQUESTS = 'RESET_PRODUCT_REQUESTS';
const SET_PAGE_INFO = 'SET_PAGE_INFO';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	pageInfo: null,
};

const getters = {
	allProductRequests: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	pageInfo: state => state.pageInfo,
};

const mutations = {
	[APPEND_PRODUCT_REQUESTS](state, productRequests) {
		state.all = state.all.concat(productRequests);
	},
	[RESET_PRODUCT_REQUESTS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_PAGE_INFO](state, pageInfo) {
		state.pageInfo = pageInfo;
	},
};

const actions = {
	getProductRequests({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				console.log(response);
				const productRequests = response.data?.product_requests ? response.data.product_requests : response.data;
				if (response.data?.page_info) {
					const pageInfo = response.data.page_info;
					commit(SET_PAGE_INFO, pageInfo);
				}
				if (productRequests !== null && productRequests.length !== 0) {
					commit(APPEND_PRODUCT_REQUESTS, productRequests);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			getProductRequests(params, callback, errorCallback);
		}
	},
	resetProductRequests({ commit }) {
		commit(RESET_PRODUCT_REQUESTS);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
